import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import { Paper } from 'material-ui';

import ProfileImage from '../app-bar/profile-image';

const { object, string } = PropTypes;

const UpdateItem = ({ companyName, profileImageUrl, style, updateType }) => (
  <Paper style={{ display: 'inline-block', height: '100%', marginBottom: '5px', width: '100%' }}>
  <div
    style={{
      verticalAlign: 'middle',
      display: 'inline-block',
      textAlign: 'center',
      width: 'calc(15%)',
      paddingLeft: '3%',
    }}
  >
  <ProfileImage
    className="profile-link-image connections-profile-link-image"
    companySlugName={companyName}
    imageUrl={profileImageUrl}
  />
  </div>
  <div
    style={{
      verticalAlign: 'middle',
      display: 'inline-block',
      width: 'calc(70%)',
    }}
  >
    <h2 style={{
      fontSize: '16px',
      lineHeight: '16px',
      paddingTop: '0',
      margin: '0px',
      letterSpacing: '-1px',
      fontWeight: '300',
      color: 'rgba(0, 0, 0, 0.54)',
    }}
    ><strong style={{ fontWeight: 500 }}>{companyName}</strong> has sent a request to connect</h2>
  </div>
  <div
    style={{
      verticalAlign: 'middle',
      display: 'inline-block',
      width: 'calc(15%)',
      textAlign: 'right',
      padding: 0,
    }}
  >
    <Link
      style={{
        display: 'inline-block',
        backgroundColor: '#ff4081',
        color: '#ffffff',
        padding: '25px',
        textTransform: 'uppercase',
        fontWeight: 400,
        fontSize: '18px',
      }}
      to={"/connections/requests"}
    >
      Go
    </Link>
  </div>
</Paper>
);

UpdateItem.propTypes = {
  companyName: string,
  style: object,
  updateType: string,
};

export default UpdateItem;



// WEBPACK FOOTER //
// ./src/app/components/dashboard/UpdateItem.jsx